import { Schema } from "@comparaonline/products-schema";
import get from "lodash.get";

import { ProviderData } from "../../../lib/appContext/types";
import { ICta } from "./types";

const getExternalRedirect = (businessUnitConfig: any) =>
  get(businessUnitConfig, "widgets.hero.config.primaryButton.href");

export const getLandingFormCta = (
  { businessUnitConfig }: ProviderData,
  product: Schema.ProductListProduct,
  onClick?: ICta["onClick"]
): ICta => ({
  disabled: !product.enabled,
  text: businessUnitConfig.resultCTA,
  url: getExternalRedirect(businessUnitConfig),
  onClick: event => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
    onClick && onClick(event);
  }
});
